import React from 'react'
import { FaLinkedinIn } from "react-icons/fa";
import { SiGithub, SiGmail } from "react-icons/si";
import { navLinksdata } from '../../constants';
import { useNavigate } from "react-router-dom";

const Footer = () => {
  const navigate = useNavigate();

  const getLinkPath = (item) => {
    if (item.link === "home") return "/";
    if (item.link === "features") return "/services";
    return `/${item.link}`;
  };

  return (
    <footer className="relative w-full bg-black text-white overflow-hidden flex-shrink-0 border-t border-white/10">
      <div className="absolute inset-0 bg-gradient-to-t from-cyan-500/5 via-transparent to-transparent pointer-events-none"></div>
      <div className="absolute bottom-0 left-1/2 -translate-x-1/2 w-[600px] h-[300px] bg-cyan-500/10 rounded-full blur-[120px] pointer-events-none"></div>

      <div className="relative z-10 max-w-7xl mx-auto px-6 pt-20 pb-10">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 mb-16">
          <div className="space-y-4">
            <div className="flex items-center space-x-2">
              <div className="w-2 h-2 bg-gradient-to-r from-cyan-400 to-blue-500 rounded-full animate-pulse"></div>
              <span className="font-serifFont font-semibold text-white tracking-wide text-lg italic">R</span>
              <span className="text-xs font-monoFont text-cyan-400">.dev()</span>
            </div>
            <p className="text-gray-400 text-sm leading-relaxed max-w-xs">
              Dedicated developer crafting production-grade cross-platform mobile apps, React web products, and AI solutions with modern, scalable engineering.
            </p>
            <div className="flex space-x-3 pt-2">
              <a href="https://www.linkedin.com/" target="_blank" rel="noopener noreferrer" className="group p-2.5 bg-white/5 border border-white/10 rounded-xl hover:border-cyan-500/50 hover:bg-cyan-500/10 transition-all duration-300 hover:shadow-lg hover:shadow-cyan-500/10 hover:-translate-y-0.5" aria-label="LinkedIn">
                <FaLinkedinIn className="h-4 w-4 text-gray-400 group-hover:text-cyan-400 transition-colors duration-200" />
              </a>
              <a href="https://github.com/" target="_blank" rel="noopener noreferrer" className="group p-2.5 bg-white/5 border border-white/10 rounded-xl hover:border-cyan-500/50 hover:bg-cyan-500/10 transition-all duration-300 hover:shadow-lg hover:shadow-cyan-500/10 hover:-translate-y-0.5" aria-label="GitHub">
                <SiGithub className="h-4 w-4 text-gray-400 group-hover:text-cyan-400 transition-colors duration-200" />
              </a>
              <a href="mailto:contact@example.com" className="group p-2.5 bg-white/5 border border-white/10 rounded-xl hover:border-cyan-500/50 hover:bg-cyan-500/10 transition-all duration-300 hover:shadow-lg hover:shadow-cyan-500/10 hover:-translate-y-0.5" aria-label="Gmail">
                <SiGmail className="h-4 w-4 text-gray-400 group-hover:text-cyan-400 transition-colors duration-200" />
              </a>
            </div>
          </div>

          <div>
            <h3 className="text-sm font-semibold text-white uppercase tracking-widest mb-6">Navigation</h3>
            <ul className="space-y-3">
              {navLinksdata.map((item) => (
                <li key={item._id}>
                  <a
                    href={getLinkPath(item)}
                    onClick={(e) => { e.preventDefault(); navigate(getLinkPath(item)); }}
                    className="text-gray-400 hover:text-cyan-400 transition-colors duration-200 text-sm flex items-center gap-2 group cursor-pointer"
                  >
                    <span className="w-0 h-px bg-cyan-400 group-hover:w-4 transition-all duration-300"></span>
                    {item.title}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="text-sm font-semibold text-white uppercase tracking-widest mb-6">Get in Touch</h3>
            <p className="text-gray-400 text-sm leading-relaxed mb-6">
              Available for full-time roles, contracts & technical leadership. Let's build something great together.
            </p>
            <a
              href="/contact"
              onClick={(e) => { e.preventDefault(); navigate("/contact"); }}
              className="inline-flex items-center gap-2 px-5 py-2.5 text-sm font-medium rounded-full border border-cyan-500/40 text-cyan-400 bg-cyan-500/5 hover:bg-cyan-500/15 hover:border-cyan-400/60 transition-all duration-300 hover:shadow-lg hover:shadow-cyan-500/10 cursor-pointer"
            >
              Start a Conversation
              <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2">
                <path strokeLinecap="round" strokeLinejoin="round" d="M17 8l4 4m0 0l-4 4m4-4H3"></path>
              </svg>
            </a>
          </div>
        </div>

        <div className="h-px bg-gradient-to-r from-transparent via-cyan-500/30 to-transparent"></div>

        <div className="flex flex-col sm:flex-row items-center justify-between gap-4 pt-8 text-xs text-gray-500">
          <p>© {new Date().getFullYear()} All rights reserved.</p>
          <p className="flex items-center gap-1.5">
            Built with <span className="text-cyan-400">React</span> & <span className="text-cyan-400">Tailwind CSS</span>
          </p>
        </div>
      </div>
    </footer>
  );
}

export default Footer
